<template>
  <div class="accordion">
    <div
      v-for="(item, index) in loadItems"
      :key="index"
      class="accordion-card"
      :class="{ active: activeIndex === index }"
    >
      <div class="accordion-card-header" @click="toggleAccordion(index)">
        <h5 v-html="item.title"></h5>
        <svg
          v-if="activeIndex === index"
          class="icon-minus"
          data-name="+ -"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="4"
          viewBox="0 0 18 4"
        >
          <rect id="meno" width="18" height="4" rx="2" fill="#d20b12" />
        </svg>
        <svg
          v-else
          class="icon-plus"
          data-name="+"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <path
            id="Icon_awesome-plus"
            data-name="Icon awesome-plus"
            d="M16.714,9.321H10.929V3.536A1.286,1.286,0,0,0,9.643,2.25H8.357A1.286,1.286,0,0,0,7.071,3.536V9.321H1.286A1.286,1.286,0,0,0,0,10.607v1.286a1.286,1.286,0,0,0,1.286,1.286H7.071v5.786A1.286,1.286,0,0,0,8.357,20.25H9.643a1.286,1.286,0,0,0,1.286-1.286V13.179h5.786A1.286,1.286,0,0,0,18,11.893V10.607A1.286,1.286,0,0,0,16.714,9.321Z"
            transform="translate(0 -2.25)"
            fill="#d20b12"
          />
        </svg>
      </div>
      <hr v-if="activeIndex === index" class="accordion-hr" />
      <div class="accordion-card-body" v-if="activeIndex === index">
        <div v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionFaq',
  props: {
    questions: {
    type: Array,
    default: () => []
  },
    type: {
      type: String,
      default: 'home',
    },
  },
  data() {
    return {
      activeIndex: null,
    };
  },
  computed: {
    loadItems() {
        if (this.questions.length) {
      return this.questions;
    }
      const items = {
        home: [
          {
            title: 'Cosa sono le Quotazioni Quattroruote?',
            content: `
            <p>Si intende la <span class="text-bold">stima indicativa di un prezzo</span> riconosciuto dal mercato e attribuito ad un veicolo con
            specificate caratteristiche descrittive e di stato. Questo valore, che in base alla tipologia di veicolo e alla sua
            anzianità ha ben definite norme di validità e applicabilità, differenti per auto e veicoli commerciali, moto e scooter e auto,
            moto e veicoli industriali con valenza collezionistica e storica è quanto fornito dal servizio descritto.
            Inoltre, è importante osservare che:
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Non esiste un veicolo uguale ad un altro.</span> Prendiamo ad esempio due autovetture identiche da nuove, con il trascorrere
                del tempo possono aver avere una "storia" d'uso, di manutenzione e riparazioni molto diversa.
              </li>
              <li>
                <span class="text-bold">Non esiste un unico mercato dell'usato.</span> Il mercato dell'usato, in realtà,
                è la somma di tanti mercati locali, poco comunicanti tra di loro e tanto più piccoli come dimensioni quanto minore è il valore della vettura oggetto di scambio.
              </li>
              <li>
                I veicoli hanno alcune <span class="text-bold">caratteristiche che la quotazione non prende in considerazione</span>,
                come il colore o la presenza di determinati equipaggiamenti, anche di post-installazione.
              </li>
            </ul>
            Non esiste quindi un <span class="text-bold">unico prezzo di transazione valido</span> per tutti gli scambi di un uguale modello di veicolo, ma un prezzo diverso secondo i casi,
            i luoghi e i momenti. È la conseguenza dei punti precedenti. Se la compravendita di due veicoli nominalmente uguali avviene su mercati dove le
            condizioni di domanda e offerta sono diverse e se l'oggetto stesso dello scambio è differente, anche i <span class="text-bold">prezzi ai quali saranno concluse le due
            transazioni risulteranno diversi.</span>
            </p>
            <p class="line-break">
              <span class="text-bold">La quotazione è quindi utile in una trattativa commerciale</span> far convergere acquirente e venditore verso un punto di partenza condiviso,
              oppure per identificare un valore a fini assicurativi e patrimoniali. Ma non è, e non può essere intesa, come la valutazione puntuale di un
              singolo esemplare di veicolo.
            </p>`,
          },
          {
            title: 'Come nascono le Quotazioni Quattroruote?',
            content: `
            <p>Le quotazioni di Quattroruote Professional sono il risultato delle più <span class="text-bold">aggiornate tecniche di analisi statistica e di accurate rilevazioni
            di mercato</span>. L'esperienza e la competenza dei nostri analisti consentono di identificare valori e metodo sempre accurati e bilanciati tra le
            esigenze dei vari attori di mercato e il consumatore, coniugando la grande qualità di questi dati con l'autorevolezza e storicità della nostra
            Casa Editrice e delle nostre testate.
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Analisi statistica</span>: attraverso l'analisi di un’enorme mole di dati, raccolta in più di 60 anni dalla banca dati di
                Quattroruote &#40;contenente caratteristiche tecnico/commerciali, prezzi di listino, quotazioni storiche di tutte le auto a mercato&#41; e
                attraverso il reperimento di informazioni di mercato strutturate, effettuata direttamente o indirettamente, possiamo alimentare sofisticati
                sistemi informatico - statistici per definire l'andamento del prezzo dei veicoli.
              </li>
              <li>
                <span class="text-bold">Rilevazioni di mercato</span>: i prezzi effettivi dei veicoli e le reali tendenze in atto sul mercato vengono
                rilevati utilizzando anche altre fonti, in particolare attraverso incontri periodici con gli operatori ed esperti di settore. Nel corso di
                questi incontri, si esaminano i risultati ottenuti attraverso l'analisi statistica e si perfezionano per tener conto dei fenomeni di mercato
                in atto.
              </li>
            </ul>
            </p>`,
          },
          {
            title: 'Come funziona il Servizio?',
            content: `
            <p>Gli utenti registrati al sito Quattroruote.it hanno la possibilità di acquistare le Quotazioni attraverso questi semplici passi:
                <ul class="faq-ul">
                    <li>
                        Esegui la <span class="text-bold">LOGIN</span>
                    </li>
                    <li>
                        <span class="text-bold">Scegli la Quotazione più adatta alle tue esigenze</span>
                    </li>
                    <li>
                        <span class="text-bold">Identifica il veicolo</span> per la quale è necessaria la Quotazione, attraverso la targa o la denominazione commerciale
                    </li>
                    <li>
                        <span class="text-bold">Effettua il pagamento o usa un codice promo se ne sei in possesso</span>. È possibile effettuare l'acquisto di
                        una quotazione tramite Carta di Credito o Paypal. L'addebito sulla carta di credito verrà effettuato solo dopo la consegna via eMail della
                        consulenza richiesta. Nel caso in cui non fosse possibile risalire in alcun modo alla Quotazione, non verrà effettuato alcun addebito.
                    </li>
                    <li>
                        <span class="text-bold">Ottieni la Quotazione</span>. L'attestato della quotazione risulterà immediatamente visualizzabile e raggiungibile
                            anche tramite il link che riceverete via eMail al termine della richiesta di quotazione e dalla propria AREA PERSONALE >LE MIE QUOTAZIONI.
                            La stessa Quotazione sarà disponibile anche attraverso l'attestato scaricabile in formato .pdf. Nel caso di richiesta di una <span class="text-bold">
                            Quotazione Storica, l'attestato della stessa non sarà disponibile immediatamente</span>, ma sarà inviato all'indirizzo eMail fornito in fase
                            di registrazione, entro cinque giorni lavorativi dalla richiesta.
                    </li>
                </ul>
            </p>`,
          },
          {
            title: 'Quotazione Nominale',
            content: `
            <p>I servizi Quotazioni di Quattroruote permettono di ricevere un attestato contenente
                                <span class="text-bold">la Quotazione puntuale per Anno e Mese di Immatricolazione di un'auto o di un veicolo commerciale leggero</span>,
                                per veicoli immatricolati in Italia negli ultimi 15 anni.
                            </p>
                            <p class="line-break">
                                Disponibili per la <span class="text-bold">quasi totalità dei veicoli commercializzati</span>, in alcuni casi &#40;come per alcuni allestimenti particolari di
                                veicoli commerciali&#41; o per alcuni periodi di immatricolazione &#40;solitamente i più lontani nel tempo&#41;
                                <span class="text-bold">le quotazioni potrebbero non essere disponibili.</span>
                                In questi casi o è presente la Quotazione Ruote Classiche o non è possibile formulare una Quotazione di mercato sufficientemente affidabile.
                                In ogni caso, solo dopo aver verificato se è presente una Quotazione per il veicolo sarà richiesto il pagamento.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">Ogni attestato conterrà il valore per vendere, comprare o assicurare</span>. Nel dettaglio:
                            </p>
                            <p class="line-break">
                                PER VENDERE
                            </p>
                            <p class="line-break">
                                La Quotazione per vendere considera e conteggia nella Quotazione molte delle caratteristiche del veicolo da valutare, come le
                                <span class="text-bold">dotazioni di alcuni optional e di equipaggiamenti qualificanti</span>
                                &#40;non tutti i possibili, ma quelli per cui il mercato riconosce un valore&#41;, i
                                <span class="text-bold">chilometri percorsi in più o in meno</span> allo standard,
                                <span class="text-bold">il mese di immatricolazione, oltre all'anno</span>,
                                tutto questo per valorizzare al meglio l'auto o il veicolo commerciale in caso di vendita.
                                Inoltre, viene fornita anche la Quotazione di ritiro che il professionista utilizza in caso di permuta del veicolo,
                                quotazione decurtata dei costi che l'operatore professionale deve sostenere per rivendere l'auto o il furgone.
                            </p>
                            <p class="line-break">
                                PER ACQUISTARE
                            </p>
                            <p class="line-break">
                                La Quotazione per comprare considera e conteggia nella Quotazione le principali caratteristiche significative di un veicolo, come le
                                <span class="text-bold">dotazioni di alcuni optional e di equipaggiamenti qualificanti</span>
                                &#40;non tutti i possibili, ma quelli per cui il mercato riconosce un valore&#41;, i
                                <span class="text-bold">chilometri percorsi in più o in meno</span> allo standard,
                                <span class="text-bold">il mese di immatricolazione, oltre all'anno</span>.
                                Inoltre, vengono forniti dei consigli utili a evitare acquisti poco convenienti o a valutare correttamente eventuali
                                servizi aggiuntivi proposti dal venditore professionale.
                            </p>
                            <p class="line-break">
                                PER ASSICURARE
                            </p>
                            <p class="line-break">
                                In caso di rinnovo della polizza incendio e furto può essere utile sapere qual è la quotazione di riferimento per la tua auto che usano le assicurazioni.
                                La Quotazione Quattroruote per assicurare ti fornisce un
                                <span class="text-bold">valore di confronto per l'auto immatricolata nell'anno o semestre specificato con la quale la compagnia calcola il premio</span>.
                                Ricordati inoltre che la polizza incendio e furto può essere disgiunta dalla polizza RC; quindi, è possibile stipulare un contratto con una diversa compagnia.
                            </p>
                            <p class="line-break">
                                VALIDITÀ
                            </p>
                            <p class="line-break">
                                Le Quotazioni Quattroruote esprimono sia il prezzo in euro a cui il veicolo può essere scambiato &#40;Quotazione di vendita&#41;,
                                il valore che il concessionario/rivenditore può attribuire quando ritira il veicolo a fronte di un nuovo acquisto
                                &#40;Quotazione di ritiro o cessione a commerciante&#41;, per veicoli immatricolati la prima volta nel periodo indicato. Le Quotazioni auto
                                <span class="text-bold">Quattroruote sono espresse comprensive d'IVA e passaggio di proprietà escluso</span>.
                                mentre per le <span class="text-bold">Quotazioni Veicoli Commerciali Leggeri e Pick-Up l'IVA è esclusa</span>.
                                Inoltre, le Quotazioni valgono per veicoli con queste caratteristiche:
                                <ul class="faq-ul">
                                    <li>
                                        <span class="text-bold">meccanica e componenti elettrici/elettronici perfettamente efficienti</span>;
                                    </li>
                                    <li>
                                        <span class="text-bold">tagliandi regolarmente eseguiti</span> e documentati &#40;per auto alimentate a gas anche i collaudi periodici previsti&#41;;
                                    </li>
                                    <li>
                                        <span class="text-bold">revisioni effettuate secondo la legge</span> &#40;riportate sulla carta di circolazione&#41;;
                                    </li>
                                    <li>
                                        <span class="text-bold">carrozzeria e interni in buone condizioni</span>, in conformità all'età e al chilometraggio;
                                    </li>
                                    <li>
                                        <span class="text-bold">pneumatici con battistrada</span> almeno al 50%;
                                    </li>
                                    <li>
                                        assenza di sinistri importanti.
                                    </li>
                                </ul>
                            </p>
                            <p class="line-break">
                                Inoltre il <span class="text-bold">chilometraggio dichiarato è confrontato rispetto a quello standard</span>
                                &#40;attribuito per ogni veicolo secondo il segmento di appartenenza e l'alimentazione&#41;
                                <span class="text-bold">per aumentare o diminuire la Quotazione</span> secondo la formula riportata in tutte le nostre pubblicazione
                                &#40;+/- lo 0,3% della quotazione di vendita ogni 1.000Km in +/- rispetto al chilometraggio standard&#41;.
                            </p>
                            <p class="line-break">
                                Ricordiamo che, a parte nel caso delle Quotazioni Storiche, la Quotazione Quattroruote è valida per il mese solare in corso,
                                l'aggiornamento delle Quotazioni per i Veicoli Commerciali Leggeri e Pick-Up avviene sempre nei mesi dispari.
                            </p>`,
          },
          {
            title: 'Report Live Market',
            content: `
            <p>Integra alla Quotazione Quattroruote una panoramica del posizionamento della tua auto sul mercato. Un'inedita elaborazione delle informazioni
                                acquisite sui principali portali di annunci di auto usate. Il Report Live Market rappresenta una vista unica e integrata per dare informazioni
                                IMMEDIATE, COMPLETE e di QUALITÀ, per permetterti di gestire la compra/vendita del veicolo al meglio delle possibilità
                            </p>`,
          },
          {
            title: 'Quotazioni Ruote Classiche',
            content: `
            <p>Il servizio Quotazioni Ruote Classiche permette di ricevere un attestato contenente la
                                <span class="text-bold">stima di valore di un veicolo con valenza storica o collezionistica &#40;auto, auto americane, moto o veicolo industriale&#41;</span>.
                                Per alcuni veicoli le Quotazioni potrebbero non essere disponibili, come nel caso della maggioranza dei veicoli fuoriserie
                                o da competizione oppure perché non è possibile formulare una quotazione di mercato sufficientemente affidabile.
                                In ogni caso, solo dopo aver verificato se è presente una Quotazione per il veicolo è presente sarà richiesto il pagamento.
                            </p>
                            <p class="line-break">
                                L'identificazione del veicolo per quale si ricerca la quotazione è strutturata per marca e anno di commercializzazione,
                                <span class="text-bold">mentre versioni, carrozzerie e a volte motorizzazioni diverse possono essere raggruppate in un unico modello</span>.
                                La quotazione non tiene conto di particolari caratteristiche del singolo esemplare come Palmàres Sportivo o Storico,
                                così come qualsiasi considerazione che possa far diventare l'esemplare un unicum.
                            </p>
                            <p class="line-break">
                                VALIDITÀ
                            </p>
                            <p class="line-break">
                                Le Quotazioni Ruote Classiche sono attribuite per ogni specifico veicolo fino ad un massimo di 7 livelli di stato,
                                denominati "label" secondo questa specifica legenda:
                            </p>
                            <p class="line-break">
                                <span class="text-bold">A+</span>
                            </p>
                            <p class="line-break">
                                Veicolo conservato in perfetto stato o completamente restaurato
                                &#40;con documentazione completa che ne attesti il ripristino&#41;, in condizioni pari al nuovo.
                                Preferibilmente dotato di documentazione e targa originali e con certificazione di un ente riconosciuto.
                                Per i veicoli più anziani la perfetta conservazione può portare a valutazioni ancora superiori, da formulare caso per caso.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">A</span>
                            </p>
                            <p class="line-break">
                                In perfetta efficienza o parzialmente restaurato e comunque in ottime condizioni, sia per le parti ripristinate sia per quelle originali.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">AB</span>
                            </p>
                            <p class="line-break">
                                In buono stato &#40;quotazione di riferimento&#41;, con manutenzione regolare e costante, anche restaurato da qualche anno.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">BA</span>
                            </p>
                            <p class="line-break">
                                In condizioni di buona originalità oppure con restauri di vecchia data, bisognoso di alcuni interventi per arrivare alla perfetta efficienza.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">B+</span>
                            </p>
                            <p class="line-break">
                                Incompleto in alcuni dettagli, marciante ma con meccanica da rivedere.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">B</span>
                            </p>
                            <p class="line-break">
                                Incompleto di carrozzeria e/o meccanica, che necessita di un restauro anche impegnativo.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">C</span>
                            </p>
                            <p class="line-break">
                                Allo stato di relitto, da considerare principalmente come fonte di ricambi.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">Non tutti i veicoli presentano tutti i gradi di riferimento.</span>
                                I motoveicoli presentano solo 3 gradi &#40;A+, AB e BA&#41;, mentre i veicoli industriali hanno una sola quotazione &#40;livello AB&#41;.
                                Inoltre, per un numero esiguo di automobili di eccezionale rarità e valore non è riscontrabile il grado C in quanto gli esemplari sono
                                stati già restaurati e non utilizzati come fonte di ricambi.
                                La <span class="text-bold">Quotazione Ruote Classiche è valida per il mese solare</span> in corso.
                            </p>`,
          },
          {
            title: 'Quotazione Storica',
            content: `
            <p>In alcuni casi necessita sapere il valore di una
                                <span class="text-bold">quotazione ad una data diversa dall'attuale</span>
                                &#40;es. per rimborso assicurativo, la quotazione di riferimento per la liquidazione è
                                quella valida alla data del furto o danno e non quella alla data della liquidazione&#41;,
                                per queste esigenze c'è il servizio Quotazione Storica. È disponibili solo se
                                <span class="text-bold">nella data di validità per cui è richiesta la quotazione</span>
                                il veicolo era quotato. Le valorizzazioni del chilometraggio, così come quelle degli equipaggiamenti e tutte
                                le ulteriori specifiche, sono quelle in uso alla data di validità della quotazione storica richiesta.
                            </p>`,
          },
        ],
        nominale: [
          {
            title: 'Cosa sono le Quotazioni Quattroruote?',
            content: `
            <p>Si intende la <span class="text-bold">stima indicativa di un prezzo</span> riconosciuto dal mercato e attribuito ad un veicolo con
            specificate caratteristiche descrittive e di stato. Questo valore, che in base alla tipologia di veicolo e alla sua
            anzianità ha ben definite norme di validità e applicabilità, differenti per auto e veicoli commerciali, moto e scooter e auto,
            moto e veicoli industriali con valenza collezionistica e storica è quanto fornito dal servizio descritto.
            Inoltre, è importante osservare che:
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Non esiste un veicolo uguale ad un altro.</span> Prendiamo ad esempio due autovetture identiche da nuove, con il trascorrere
                del tempo possono aver avere una "storia" d'uso, di manutenzione e riparazioni molto diversa.
              </li>
              <li>
                <span class="text-bold">Non esiste un unico mercato dell'usato.</span> Il mercato dell'usato, in realtà,
                è la somma di tanti mercati locali, poco comunicanti tra di loro e tanto più piccoli come dimensioni quanto minore è il valore della vettura oggetto di scambio.
              </li>
              <li>
                I veicoli hanno alcune <span class="text-bold">caratteristiche che la quotazione non prende in considerazione</span>,
                come il colore o la presenza di determinati equipaggiamenti, anche di post-installazione.
              </li>
            </ul>
            Non esiste quindi un <span class="text-bold">unico prezzo di transazione valido</span> per tutti gli scambi di un uguale modello di veicolo, ma un prezzo diverso secondo i casi,
            i luoghi e i momenti. È la conseguenza dei punti precedenti. Se la compravendita di due veicoli nominalmente uguali avviene su mercati dove le
            condizioni di domanda e offerta sono diverse e se l'oggetto stesso dello scambio è differente, anche i <span class="text-bold">prezzi ai quali saranno concluse le due
            transazioni risulteranno diversi.</span>
            </p>
            <p class="line-break">
              <span class="text-bold">La quotazione è quindi utile in una trattativa commerciale</span> far convergere acquirente e venditore verso un punto di partenza condiviso,
              oppure per identificare un valore a fini assicurativi e patrimoniali. Ma non è, e non può essere intesa, come la valutazione puntuale di un
              singolo esemplare di veicolo.
            </p>`,
          },
          {
            title: 'Come nascono le Quotazioni Quattroruote?',
            content: `
            <p>Le quotazioni di Quattroruote Professional sono il risultato delle più <span class="text-bold">aggiornate tecniche di analisi statistica e di accurate rilevazioni
            di mercato</span>. L'esperienza e la competenza dei nostri analisti consentono di identificare valori e metodo sempre accurati e bilanciati tra le
            esigenze dei vari attori di mercato e il consumatore, coniugando la grande qualità di questi dati con l'autorevolezza e storicità della nostra
            Casa Editrice e delle nostre testate.
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Analisi statistica</span>: attraverso l'analisi di un’enorme mole di dati, raccolta in più di 60 anni dalla banca dati di
                Quattroruote &#40;contenente caratteristiche tecnico/commerciali, prezzi di listino, quotazioni storiche di tutte le auto a mercato&#41; e
                attraverso il reperimento di informazioni di mercato strutturate, effettuata direttamente o indirettamente, possiamo alimentare sofisticati
                sistemi informatico - statistici per definire l'andamento del prezzo dei veicoli.
              </li>
              <li>
                <span class="text-bold">Rilevazioni di mercato</span>: i prezzi effettivi dei veicoli e le reali tendenze in atto sul mercato vengono
                rilevati utilizzando anche altre fonti, in particolare attraverso incontri periodici con gli operatori ed esperti di settore. Nel corso di
                questi incontri, si esaminano i risultati ottenuti attraverso l'analisi statistica e si perfezionano per tener conto dei fenomeni di mercato
                in atto.
              </li>
            </ul>
            </p>`,
          },
          {
            title: 'Come funziona il Servizio?',
            content: `
            <p>Gli utenti registrati al sito Quattroruote.it hanno la possibilità di acquistare le Quotazioni attraverso questi semplici passi:
                <ul class="faq-ul">
                    <li>
                        Esegui la <span class="text-bold">LOGIN</span>
                    </li>
                    <li>
                        <span class="text-bold">Scegli la Quotazione più adatta alle tue esigenze</span>
                    </li>
                    <li>
                        <span class="text-bold">Identifica il veicolo</span> per la quale è necessaria la Quotazione, attraverso la targa o la denominazione commerciale
                    </li>
                    <li>
                        <span class="text-bold">Effettua il pagamento o usa un codice promo se ne sei in possesso</span>. È possibile effettuare l'acquisto di
                        una quotazione tramite Carta di Credito o Paypal. L'addebito sulla carta di credito verrà effettuato solo dopo la consegna via eMail della
                        consulenza richiesta. Nel caso in cui non fosse possibile risalire in alcun modo alla Quotazione, non verrà effettuato alcun addebito.
                    </li>
                    <li>
                        <span class="text-bold">Ottieni la Quotazione</span>. L'attestato della quotazione risulterà immediatamente visualizzabile e raggiungibile
                            anche tramite il link che riceverete via eMail al termine della richiesta di quotazione e dalla propria AREA PERSONALE >LE MIE QUOTAZIONI.
                            La stessa Quotazione sarà disponibile anche attraverso l'attestato scaricabile in formato .pdf. Nel caso di richiesta di una <span class="text-bold">
                            Quotazione Storica, l'attestato della stessa non sarà disponibile immediatamente</span>, ma sarà inviato all'indirizzo eMail fornito in fase
                            di registrazione, entro cinque giorni lavorativi dalla richiesta.
                    </li>
                </ul>
            </p>`,
          },
          {
            title: 'Quotazione Nominale',
            content: `
            <p>I servizi Quotazioni di Quattroruote permettono di ricevere un attestato contenente
                                <span class="text-bold">la Quotazione puntuale per Anno e Mese di Immatricolazione di un'auto o di un veicolo commerciale leggero</span>,
                                per veicoli immatricolati in Italia negli ultimi 15 anni.
                            </p>
                            <p class="line-break">
                                Disponibili per la <span class="text-bold">quasi totalità dei veicoli commercializzati</span>, in alcuni casi &#40;come per alcuni allestimenti particolari di
                                veicoli commerciali&#41; o per alcuni periodi di immatricolazione &#40;solitamente i più lontani nel tempo&#41;
                                <span class="text-bold">le quotazioni potrebbero non essere disponibili.</span>
                                In questi casi o è presente la Quotazione Ruote Classiche o non è possibile formulare una Quotazione di mercato sufficientemente affidabile.
                                In ogni caso, solo dopo aver verificato se è presente una Quotazione per il veicolo sarà richiesto il pagamento.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">Ogni attestato conterrà il valore per vendere, comprare o assicurare</span>. Nel dettaglio:
                            </p>
                            <p class="line-break">
                                PER VENDERE
                            </p>
                            <p class="line-break">
                                La Quotazione per vendere considera e conteggia nella Quotazione molte delle caratteristiche del veicolo da valutare, come le
                                <span class="text-bold">dotazioni di alcuni optional e di equipaggiamenti qualificanti</span>
                                &#40;non tutti i possibili, ma quelli per cui il mercato riconosce un valore&#41;, i
                                <span class="text-bold">chilometri percorsi in più o in meno</span> allo standard,
                                <span class="text-bold">il mese di immatricolazione, oltre all'anno</span>,
                                tutto questo per valorizzare al meglio l'auto o il veicolo commerciale in caso di vendita.
                                Inoltre, viene fornita anche la Quotazione di ritiro che il professionista utilizza in caso di permuta del veicolo,
                                quotazione decurtata dei costi che l'operatore professionale deve sostenere per rivendere l'auto o il furgone.
                            </p>
                            <p class="line-break">
                                PER ACQUISTARE
                            </p>
                            <p class="line-break">
                                La Quotazione per comprare considera e conteggia nella Quotazione le principali caratteristiche significative di un veicolo, come le
                                <span class="text-bold">dotazioni di alcuni optional e di equipaggiamenti qualificanti</span>
                                &#40;non tutti i possibili, ma quelli per cui il mercato riconosce un valore&#41;, i
                                <span class="text-bold">chilometri percorsi in più o in meno</span> allo standard,
                                <span class="text-bold">il mese di immatricolazione, oltre all'anno</span>.
                                Inoltre, vengono forniti dei consigli utili a evitare acquisti poco convenienti o a valutare correttamente eventuali
                                servizi aggiuntivi proposti dal venditore professionale.
                            </p>
                            <p class="line-break">
                                PER ASSICURARE
                            </p>
                            <p class="line-break">
                                In caso di rinnovo della polizza incendio e furto può essere utile sapere qual è la quotazione di riferimento per la tua auto che usano le assicurazioni.
                                La Quotazione Quattroruote per assicurare ti fornisce un
                                <span class="text-bold">valore di confronto per l'auto immatricolata nell'anno o semestre specificato con la quale la compagnia calcola il premio</span>.
                                Ricordati inoltre che la polizza incendio e furto può essere disgiunta dalla polizza RC; quindi, è possibile stipulare un contratto con una diversa compagnia.
                            </p>
                            <p class="line-break">
                                VALIDITÀ
                            </p>
                            <p class="line-break">
                                Le Quotazioni Quattroruote esprimono sia il prezzo in euro a cui il veicolo può essere scambiato &#40;Quotazione di vendita&#41;,
                                il valore che il concessionario/rivenditore può attribuire quando ritira il veicolo a fronte di un nuovo acquisto
                                &#40;Quotazione di ritiro o cessione a commerciante&#41;, per veicoli immatricolati la prima volta nel periodo indicato. Le Quotazioni auto
                                <span class="text-bold">Quattroruote sono espresse comprensive d'IVA e passaggio di proprietà escluso</span>.
                                mentre per le <span class="text-bold">Quotazioni Veicoli Commerciali Leggeri e Pick-Up l'IVA è esclusa</span>.
                                Inoltre, le Quotazioni valgono per veicoli con queste caratteristiche:
                                <ul class="faq-ul">
                                    <li>
                                        <span class="text-bold">meccanica e componenti elettrici/elettronici perfettamente efficienti</span>;
                                    </li>
                                    <li>
                                        <span class="text-bold">tagliandi regolarmente eseguiti</span> e documentati &#40;per auto alimentate a gas anche i collaudi periodici previsti&#41;;
                                    </li>
                                    <li>
                                        <span class="text-bold">revisioni effettuate secondo la legge</span> &#40;riportate sulla carta di circolazione&#41;;
                                    </li>
                                    <li>
                                        <span class="text-bold">carrozzeria e interni in buone condizioni</span>, in conformità all'età e al chilometraggio;
                                    </li>
                                    <li>
                                        <span class="text-bold">pneumatici con battistrada</span> almeno al 50%;
                                    </li>
                                    <li>
                                        assenza di sinistri importanti.
                                    </li>
                                </ul>
                            </p>
                            <p class="line-break">
                                Inoltre il <span class="text-bold">chilometraggio dichiarato è confrontato rispetto a quello standard</span>
                                &#40;attribuito per ogni veicolo secondo il segmento di appartenenza e l'alimentazione&#41;
                                <span class="text-bold">per aumentare o diminuire la Quotazione</span> secondo la formula riportata in tutte le nostre pubblicazione
                                &#40;+/- lo 0,3% della quotazione di vendita ogni 1.000Km in +/- rispetto al chilometraggio standard&#41;.
                            </p>
                            <p class="line-break">
                                Ricordiamo che, a parte nel caso delle Quotazioni Storiche, la Quotazione Quattroruote è valida per il mese solare in corso,
                                l'aggiornamento delle Quotazioni per i Veicoli Commerciali Leggeri e Pick-Up avviene sempre nei mesi dispari.
                            </p>`,
          },
        ],
        'live-market': [
          {
            title: 'Cosa sono le Quotazioni Quattroruote?',
            content: `
            <p>Si intende la <span class="text-bold">stima indicativa di un prezzo</span> riconosciuto dal mercato e attribuito ad un veicolo con
            specificate caratteristiche descrittive e di stato. Questo valore, che in base alla tipologia di veicolo e alla sua
            anzianità ha ben definite norme di validità e applicabilità, differenti per auto e veicoli commerciali, moto e scooter e auto,
            moto e veicoli industriali con valenza collezionistica e storica è quanto fornito dal servizio descritto.
            Inoltre, è importante osservare che:
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Non esiste un veicolo uguale ad un altro.</span> Prendiamo ad esempio due autovetture identiche da nuove, con il trascorrere
                del tempo possono aver avere una "storia" d'uso, di manutenzione e riparazioni molto diversa.
              </li>
              <li>
                <span class="text-bold">Non esiste un unico mercato dell'usato.</span> Il mercato dell'usato, in realtà,
                è la somma di tanti mercati locali, poco comunicanti tra di loro e tanto più piccoli come dimensioni quanto minore è il valore della vettura oggetto di scambio.
              </li>
              <li>
                I veicoli hanno alcune <span class="text-bold">caratteristiche che la quotazione non prende in considerazione</span>,
                come il colore o la presenza di determinati equipaggiamenti, anche di post-installazione.
              </li>
            </ul>
            Non esiste quindi un <span class="text-bold">unico prezzo di transazione valido</span> per tutti gli scambi di un uguale modello di veicolo, ma un prezzo diverso secondo i casi,
            i luoghi e i momenti. È la conseguenza dei punti precedenti. Se la compravendita di due veicoli nominalmente uguali avviene su mercati dove le
            condizioni di domanda e offerta sono diverse e se l'oggetto stesso dello scambio è differente, anche i <span class="text-bold">prezzi ai quali saranno concluse le due
            transazioni risulteranno diversi.</span>
            </p>
            <p class="line-break">
              <span class="text-bold">La quotazione è quindi utile in una trattativa commerciale</span> far convergere acquirente e venditore verso un punto di partenza condiviso,
              oppure per identificare un valore a fini assicurativi e patrimoniali. Ma non è, e non può essere intesa, come la valutazione puntuale di un
              singolo esemplare di veicolo.
            </p>`,
          },
          {
            title: 'Come nascono le Quotazioni Quattroruote?',
            content: `
            <p>Le quotazioni di Quattroruote Professional sono il risultato delle più <span class="text-bold">aggiornate tecniche di analisi statistica e di accurate rilevazioni
            di mercato</span>. L'esperienza e la competenza dei nostri analisti consentono di identificare valori e metodo sempre accurati e bilanciati tra le
            esigenze dei vari attori di mercato e il consumatore, coniugando la grande qualità di questi dati con l'autorevolezza e storicità della nostra
            Casa Editrice e delle nostre testate.
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Analisi statistica</span>: attraverso l'analisi di un’enorme mole di dati, raccolta in più di 60 anni dalla banca dati di
                Quattroruote &#40;contenente caratteristiche tecnico/commerciali, prezzi di listino, quotazioni storiche di tutte le auto a mercato&#41; e
                attraverso il reperimento di informazioni di mercato strutturate, effettuata direttamente o indirettamente, possiamo alimentare sofisticati
                sistemi informatico - statistici per definire l'andamento del prezzo dei veicoli.
              </li>
              <li>
                <span class="text-bold">Rilevazioni di mercato</span>: i prezzi effettivi dei veicoli e le reali tendenze in atto sul mercato vengono
                rilevati utilizzando anche altre fonti, in particolare attraverso incontri periodici con gli operatori ed esperti di settore. Nel corso di
                questi incontri, si esaminano i risultati ottenuti attraverso l'analisi statistica e si perfezionano per tener conto dei fenomeni di mercato
                in atto.
              </li>
            </ul>
            </p>`,
          },
          {
            title: 'Come funziona il Servizio?',
            content: `
            <p>Gli utenti registrati al sito Quattroruote.it hanno la possibilità di acquistare le Quotazioni attraverso questi semplici passi:
                <ul class="faq-ul">
                    <li>
                        Esegui la <span class="text-bold">LOGIN</span>
                    </li>
                    <li>
                        <span class="text-bold">Scegli la Quotazione più adatta alle tue esigenze</span>
                    </li>
                    <li>
                        <span class="text-bold">Identifica il veicolo</span> per la quale è necessaria la Quotazione, attraverso la targa o la denominazione commerciale
                    </li>
                    <li>
                        <span class="text-bold">Effettua il pagamento o usa un codice promo se ne sei in possesso</span>. È possibile effettuare l'acquisto di
                        una quotazione tramite Carta di Credito o Paypal. L'addebito sulla carta di credito verrà effettuato solo dopo la consegna via eMail della
                        consulenza richiesta. Nel caso in cui non fosse possibile risalire in alcun modo alla Quotazione, non verrà effettuato alcun addebito.
                    </li>
                    <li>
                        <span class="text-bold">Ottieni la Quotazione</span>. L'attestato della quotazione risulterà immediatamente visualizzabile e raggiungibile
                            anche tramite il link che riceverete via eMail al termine della richiesta di quotazione e dalla propria AREA PERSONALE >LE MIE QUOTAZIONI.
                            La stessa Quotazione sarà disponibile anche attraverso l'attestato scaricabile in formato .pdf. Nel caso di richiesta di una <span class="text-bold">
                            Quotazione Storica, l'attestato della stessa non sarà disponibile immediatamente</span>, ma sarà inviato all'indirizzo eMail fornito in fase
                            di registrazione, entro cinque giorni lavorativi dalla richiesta.
                    </li>
                </ul>
            </p>`,
          },
          {
            title: 'Report Live Market',
            content: `
            <p>Integra alla Quotazione Quattroruote una panoramica del posizionamento della tua auto sul mercato. Un'inedita elaborazione delle informazioni
                                acquisite sui principali portali di annunci di auto usate. Il Report Live Market rappresenta una vista unica e integrata per dare informazioni
                                IMMEDIATE, COMPLETE e di QUALITÀ, per permetterti di gestire la compra/vendita del veicolo al meglio delle possibilità
                            </p>`,
          },
        ],
        storica: [
          {
            title: 'Cosa sono le Quotazioni Quattroruote?',
            content: `
            <p>Si intende la <span class="text-bold">stima indicativa di un prezzo</span> riconosciuto dal mercato e attribuito ad un veicolo con
            specificate caratteristiche descrittive e di stato. Questo valore, che in base alla tipologia di veicolo e alla sua
            anzianità ha ben definite norme di validità e applicabilità, differenti per auto e veicoli commerciali, moto e scooter e auto,
            moto e veicoli industriali con valenza collezionistica e storica è quanto fornito dal servizio descritto.
            Inoltre, è importante osservare che:
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Non esiste un veicolo uguale ad un altro.</span> Prendiamo ad esempio due autovetture identiche da nuove, con il trascorrere
                del tempo possono aver avere una "storia" d'uso, di manutenzione e riparazioni molto diversa.
              </li>
              <li>
                <span class="text-bold">Non esiste un unico mercato dell'usato.</span> Il mercato dell'usato, in realtà,
                è la somma di tanti mercati locali, poco comunicanti tra di loro e tanto più piccoli come dimensioni quanto minore è il valore della vettura oggetto di scambio.
              </li>
              <li>
                I veicoli hanno alcune <span class="text-bold">caratteristiche che la quotazione non prende in considerazione</span>,
                come il colore o la presenza di determinati equipaggiamenti, anche di post-installazione.
              </li>
            </ul>
            Non esiste quindi un <span class="text-bold">unico prezzo di transazione valido</span> per tutti gli scambi di un uguale modello di veicolo, ma un prezzo diverso secondo i casi,
            i luoghi e i momenti. È la conseguenza dei punti precedenti. Se la compravendita di due veicoli nominalmente uguali avviene su mercati dove le
            condizioni di domanda e offerta sono diverse e se l'oggetto stesso dello scambio è differente, anche i <span class="text-bold">prezzi ai quali saranno concluse le due
            transazioni risulteranno diversi.</span>
            </p>
            <p class="line-break">
              <span class="text-bold">La quotazione è quindi utile in una trattativa commerciale</span> far convergere acquirente e venditore verso un punto di partenza condiviso,
              oppure per identificare un valore a fini assicurativi e patrimoniali. Ma non è, e non può essere intesa, come la valutazione puntuale di un
              singolo esemplare di veicolo.
            </p>`,
          },
          {
            title: 'Come nascono le Quotazioni Quattroruote?',
            content: `
            <p>Le quotazioni di Quattroruote Professional sono il risultato delle più <span class="text-bold">aggiornate tecniche di analisi statistica e di accurate rilevazioni
            di mercato</span>. L'esperienza e la competenza dei nostri analisti consentono di identificare valori e metodo sempre accurati e bilanciati tra le
            esigenze dei vari attori di mercato e il consumatore, coniugando la grande qualità di questi dati con l'autorevolezza e storicità della nostra
            Casa Editrice e delle nostre testate.
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Analisi statistica</span>: attraverso l'analisi di un’enorme mole di dati, raccolta in più di 60 anni dalla banca dati di
                Quattroruote &#40;contenente caratteristiche tecnico/commerciali, prezzi di listino, quotazioni storiche di tutte le auto a mercato&#41; e
                attraverso il reperimento di informazioni di mercato strutturate, effettuata direttamente o indirettamente, possiamo alimentare sofisticati
                sistemi informatico - statistici per definire l'andamento del prezzo dei veicoli.
              </li>
              <li>
                <span class="text-bold">Rilevazioni di mercato</span>: i prezzi effettivi dei veicoli e le reali tendenze in atto sul mercato vengono
                rilevati utilizzando anche altre fonti, in particolare attraverso incontri periodici con gli operatori ed esperti di settore. Nel corso di
                questi incontri, si esaminano i risultati ottenuti attraverso l'analisi statistica e si perfezionano per tener conto dei fenomeni di mercato
                in atto.
              </li>
            </ul>
            </p>`,
          },
          {
            title: 'Come funziona il Servizio?',
            content: `
            <p>Gli utenti registrati al sito Quattroruote.it hanno la possibilità di acquistare le Quotazioni attraverso questi semplici passi:
                <ul class="faq-ul">
                    <li>
                        Esegui la <span class="text-bold">LOGIN</span>
                    </li>
                    <li>
                        <span class="text-bold">Scegli la Quotazione più adatta alle tue esigenze</span>
                    </li>
                    <li>
                        <span class="text-bold">Identifica il veicolo</span> per la quale è necessaria la Quotazione, attraverso la targa o la denominazione commerciale
                    </li>
                    <li>
                        <span class="text-bold">Effettua il pagamento o usa un codice promo se ne sei in possesso</span>. È possibile effettuare l'acquisto di
                        una quotazione tramite Carta di Credito o Paypal. L'addebito sulla carta di credito verrà effettuato solo dopo la consegna via eMail della
                        consulenza richiesta. Nel caso in cui non fosse possibile risalire in alcun modo alla Quotazione, non verrà effettuato alcun addebito.
                    </li>
                    <li>
                        <span class="text-bold">Ottieni la Quotazione</span>. L'attestato della quotazione risulterà immediatamente visualizzabile e raggiungibile
                            anche tramite il link che riceverete via eMail al termine della richiesta di quotazione e dalla propria AREA PERSONALE >LE MIE QUOTAZIONI.
                            La stessa Quotazione sarà disponibile anche attraverso l'attestato scaricabile in formato .pdf. Nel caso di richiesta di una <span class="text-bold">
                            Quotazione Storica, l'attestato della stessa non sarà disponibile immediatamente</span>, ma sarà inviato all'indirizzo eMail fornito in fase
                            di registrazione, entro cinque giorni lavorativi dalla richiesta.
                    </li>
                </ul>
            </p>`,
          },
          {
            title: 'Quotazione Storica',
            content: `
            <p>In alcuni casi necessita sapere il valore di una
                                <span class="text-bold">quotazione ad una data diversa dall'attuale</span>
                                &#40;es. per rimborso assicurativo, la quotazione di riferimento per la liquidazione è
                                quella valida alla data del furto o danno e non quella alla data della liquidazione&#41;,
                                per queste esigenze c'è il servizio Quotazione Storica. È disponibili solo se
                                <span class="text-bold">nella data di validità per cui è richiesta la quotazione</span>
                                il veicolo era quotato. Le valorizzazioni del chilometraggio, così come quelle degli equipaggiamenti e tutte
                                le ulteriori specifiche, sono quelle in uso alla data di validità della quotazione storica richiesta.
                            </p>`,
          },
        ],
        'ruote-classiche': [
          {
            title: 'Cosa sono le Quotazioni Quattroruote?',
            content: `
            <p>Si intende la <span class="text-bold">stima indicativa di un prezzo</span> riconosciuto dal mercato e attribuito ad un veicolo con
            specificate caratteristiche descrittive e di stato. Questo valore, che in base alla tipologia di veicolo e alla sua
            anzianità ha ben definite norme di validità e applicabilità, differenti per auto e veicoli commerciali, moto e scooter e auto,
            moto e veicoli industriali con valenza collezionistica e storica è quanto fornito dal servizio descritto.
            Inoltre, è importante osservare che:
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Non esiste un veicolo uguale ad un altro.</span> Prendiamo ad esempio due autovetture identiche da nuove, con il trascorrere
                del tempo possono aver avere una "storia" d'uso, di manutenzione e riparazioni molto diversa.
              </li>
              <li>
                <span class="text-bold">Non esiste un unico mercato dell'usato.</span> Il mercato dell'usato, in realtà,
                è la somma di tanti mercati locali, poco comunicanti tra di loro e tanto più piccoli come dimensioni quanto minore è il valore della vettura oggetto di scambio.
              </li>
              <li>
                I veicoli hanno alcune <span class="text-bold">caratteristiche che la quotazione non prende in considerazione</span>,
                come il colore o la presenza di determinati equipaggiamenti, anche di post-installazione.
              </li>
            </ul>
            Non esiste quindi un <span class="text-bold">unico prezzo di transazione valido</span> per tutti gli scambi di un uguale modello di veicolo, ma un prezzo diverso secondo i casi,
            i luoghi e i momenti. È la conseguenza dei punti precedenti. Se la compravendita di due veicoli nominalmente uguali avviene su mercati dove le
            condizioni di domanda e offerta sono diverse e se l'oggetto stesso dello scambio è differente, anche i <span class="text-bold">prezzi ai quali saranno concluse le due
            transazioni risulteranno diversi.</span>
            </p>
            <p class="line-break">
              <span class="text-bold">La quotazione è quindi utile in una trattativa commerciale</span> far convergere acquirente e venditore verso un punto di partenza condiviso,
              oppure per identificare un valore a fini assicurativi e patrimoniali. Ma non è, e non può essere intesa, come la valutazione puntuale di un
              singolo esemplare di veicolo.
            </p>`,
          },
          {
            title: 'Come nascono le Quotazioni Quattroruote?',
            content: `
            <p>Le quotazioni di Quattroruote Professional sono il risultato delle più <span class="text-bold">aggiornate tecniche di analisi statistica e di accurate rilevazioni
            di mercato</span>. L'esperienza e la competenza dei nostri analisti consentono di identificare valori e metodo sempre accurati e bilanciati tra le
            esigenze dei vari attori di mercato e il consumatore, coniugando la grande qualità di questi dati con l'autorevolezza e storicità della nostra
            Casa Editrice e delle nostre testate.
            <ul class="faq-ul">
              <li>
                <span class="text-bold">Analisi statistica</span>: attraverso l'analisi di un’enorme mole di dati, raccolta in più di 60 anni dalla banca dati di
                Quattroruote &#40;contenente caratteristiche tecnico/commerciali, prezzi di listino, quotazioni storiche di tutte le auto a mercato&#41; e
                attraverso il reperimento di informazioni di mercato strutturate, effettuata direttamente o indirettamente, possiamo alimentare sofisticati
                sistemi informatico - statistici per definire l'andamento del prezzo dei veicoli.
              </li>
              <li>
                <span class="text-bold">Rilevazioni di mercato</span>: i prezzi effettivi dei veicoli e le reali tendenze in atto sul mercato vengono
                rilevati utilizzando anche altre fonti, in particolare attraverso incontri periodici con gli operatori ed esperti di settore. Nel corso di
                questi incontri, si esaminano i risultati ottenuti attraverso l'analisi statistica e si perfezionano per tener conto dei fenomeni di mercato
                in atto.
              </li>
            </ul>
            </p>`,
          },
          {
            title: 'Come funziona il Servizio?',
            content: `
            <p>Gli utenti registrati al sito Quattroruote.it hanno la possibilità di acquistare le Quotazioni attraverso questi semplici passi:
                <ul class="faq-ul">
                    <li>
                        Esegui la <span class="text-bold">LOGIN</span>
                    </li>
                    <li>
                        <span class="text-bold">Scegli la Quotazione più adatta alle tue esigenze</span>
                    </li>
                    <li>
                        <span class="text-bold">Identifica il veicolo</span> per la quale è necessaria la Quotazione, attraverso la targa o la denominazione commerciale
                    </li>
                    <li>
                        <span class="text-bold">Effettua il pagamento o usa un codice promo se ne sei in possesso</span>. È possibile effettuare l'acquisto di
                        una quotazione tramite Carta di Credito o Paypal. L'addebito sulla carta di credito verrà effettuato solo dopo la consegna via eMail della
                        consulenza richiesta. Nel caso in cui non fosse possibile risalire in alcun modo alla Quotazione, non verrà effettuato alcun addebito.
                    </li>
                    <li>
                        <span class="text-bold">Ottieni la Quotazione</span>. L'attestato della quotazione risulterà immediatamente visualizzabile e raggiungibile
                            anche tramite il link che riceverete via eMail al termine della richiesta di quotazione e dalla propria AREA PERSONALE >LE MIE QUOTAZIONI.
                            La stessa Quotazione sarà disponibile anche attraverso l'attestato scaricabile in formato .pdf. Nel caso di richiesta di una <span class="text-bold">
                            Quotazione Storica, l'attestato della stessa non sarà disponibile immediatamente</span>, ma sarà inviato all'indirizzo eMail fornito in fase
                            di registrazione, entro cinque giorni lavorativi dalla richiesta.
                    </li>
                </ul>
            </p>`,
          },
          {
            title: 'Quotazioni Ruote Classiche',
            content: `
            <p>Il servizio Quotazioni Ruote Classiche permette di ricevere un attestato contenente la
                                <span class="text-bold">stima di valore di un veicolo con valenza storica o collezionistica &#40;auto, auto americane, moto o veicolo industriale&#41;</span>.
                                Per alcuni veicoli le Quotazioni potrebbero non essere disponibili, come nel caso della maggioranza dei veicoli fuoriserie
                                o da competizione oppure perché non è possibile formulare una quotazione di mercato sufficientemente affidabile.
                                In ogni caso, solo dopo aver verificato se è presente una Quotazione per il veicolo è presente sarà richiesto il pagamento.
                            </p>
                            <p class="line-break">
                                L'identificazione del veicolo per quale si ricerca la quotazione è strutturata per marca e anno di commercializzazione,
                                <span class="text-bold">mentre versioni, carrozzerie e a volte motorizzazioni diverse possono essere raggruppate in un unico modello</span>.
                                La quotazione non tiene conto di particolari caratteristiche del singolo esemplare come Palmàres Sportivo o Storico,
                                così come qualsiasi considerazione che possa far diventare l'esemplare un unicum.
                            </p>
                            <p class="line-break">
                                VALIDITÀ
                            </p>
                            <p class="line-break">
                                Le Quotazioni Ruote Classiche sono attribuite per ogni specifico veicolo fino ad un massimo di 7 livelli di stato,
                                denominati "label" secondo questa specifica legenda:
                            </p>
                            <p class="line-break">
                                <span class="text-bold">A+</span>
                            </p>
                            <p class="line-break">
                                Veicolo conservato in perfetto stato o completamente restaurato
                                &#40;con documentazione completa che ne attesti il ripristino&#41;, in condizioni pari al nuovo.
                                Preferibilmente dotato di documentazione e targa originali e con certificazione di un ente riconosciuto.
                                Per i veicoli più anziani la perfetta conservazione può portare a valutazioni ancora superiori, da formulare caso per caso.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">A</span>
                            </p>
                            <p class="line-break">
                                In perfetta efficienza o parzialmente restaurato e comunque in ottime condizioni, sia per le parti ripristinate sia per quelle originali.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">AB</span>
                            </p>
                            <p class="line-break">
                                In buono stato &#40;quotazione di riferimento&#41;, con manutenzione regolare e costante, anche restaurato da qualche anno.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">BA</span>
                            </p>
                            <p class="line-break">
                                In condizioni di buona originalità oppure con restauri di vecchia data, bisognoso di alcuni interventi per arrivare alla perfetta efficienza.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">B+</span>
                            </p>
                            <p class="line-break">
                                Incompleto in alcuni dettagli, marciante ma con meccanica da rivedere.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">B</span>
                            </p>
                            <p class="line-break">
                                Incompleto di carrozzeria e/o meccanica, che necessita di un restauro anche impegnativo.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">C</span>
                            </p>
                            <p class="line-break">
                                Allo stato di relitto, da considerare principalmente come fonte di ricambi.
                            </p>
                            <p class="line-break">
                                <span class="text-bold">Non tutti i veicoli presentano tutti i gradi di riferimento.</span>
                                I motoveicoli presentano solo 3 gradi &#40;A+, AB e BA&#41;, mentre i veicoli industriali hanno una sola quotazione &#40;livello AB&#41;.
                                Inoltre, per un numero esiguo di automobili di eccezionale rarità e valore non è riscontrabile il grado C in quanto gli esemplari sono
                                stati già restaurati e non utilizzati come fonte di ricambi.
                                La <span class="text-bold">Quotazione Ruote Classiche è valida per il mese solare</span> in corso.
                            </p>`,
          },
        ],
      };
      return items[this.type];
    },
  },
  methods: {
    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/AccordionFaq.vue